import axiosClient from './axiosClient';
import { apiPath } from '../../utils/api-contants';
import { ServicesDataRequestPayloadTypes } from '../models/platform-master';

const platformServicesMasterService = {
  fetchServices: async (payload: ServicesDataRequestPayloadTypes) => {
    try {
      const apiResponse: any = await axiosClient.get(apiPath.THINGS_SERVICES_BASE_URL, { params: payload });
      const res: any = apiResponse.data;
      return {
        status: 'success',
        code: apiResponse?.status,
        res,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },

  fetchServiceById: async (payload: any) => {
    try {
      const apiResponse: any = await axiosClient.get(`${apiPath.THINGS_SERVICES_BASE_URL}/${payload.service_id}`);
      const res: any = apiResponse.data;
      return {
        status: 'success',
        code: apiResponse?.status,
        res,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },

  addService: async (payload: object) => {
    try {
      const apiResponse = await axiosClient.post(apiPath.THINGS_SERVICES_BASE_URL, payload);
      return {
        status: 'success',
        code: apiResponse?.status,
        data: apiResponse.data,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },

  updateService: async (payload: any) => {
    try {
      const apiResponse = await axiosClient.patch(`${apiPath.THINGS_SERVICES_BASE_URL}/${payload.service_id}`, payload);
      const res: any = apiResponse.data;
      return {
        status: 'success',
        code: apiResponse?.status,
        data: { payload, res },
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  removeService: async (payload: any) => {
    try {
      const apiResponse = await axiosClient.delete(`${apiPath.THINGS_SERVICES_BASE_URL}/${payload.service_id}`);
      const res: any = apiResponse.data;
      return {
        status: 'success',
        code: apiResponse?.status,
        data: { payload, res },
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
};

export default platformServicesMasterService;
